if (!customElements.get('product-model-view')) {
  customElements.define('product-model-view', class ProductModelView extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.getParam = 'view-option';
      this.getElements();
      this.addEventListeners();
    }

    addOrUpdateURLParam(key, value) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set(key, value);
      const newSearchParams = searchParams.toString();
      history.pushState({ newSearchParams }, '', `${window.location.pathname}${newSearchParams && '?'.concat(newSearchParams)}`);
    }

    getElements() {
      this.productView = this.querySelector('[data-product-view]');
      this.modelView = this.querySelector('[data-model-view]');
    }

    toggleProductModelViewButton(option) {
      switch (option) {
        case this.productView.dataset.view:
          this.productView.classList.add('active');
          this.modelView.classList.remove('active');
          break;
        case this.modelView.dataset.view:
          this.productView.classList.remove('active');
          this.modelView.classList.add('active');
      };
      this.setImageSourcesBasedOnProductViewOption(option);
    }

    setImageSourcesBasedOnProductViewOption(option) {
      this.productGridItems = this.closest(`#shopify-section-${this.dataset.uniqueId}`).querySelectorAll('product-card-item');
      for (const productGridItem of this.productGridItems) {
        let dataHoverImg = productGridItem.querySelector('.media').dataset.hoverImg;
        let dataProductImg = productGridItem.querySelector('img').dataset.productImg;
        let dataModelImg = productGridItem.querySelector('img').dataset.modelImg;
        switch (option) {
          case this.productView.dataset.view:
            productGridItem.querySelector('img').setAttribute('srcset', dataProductImg);
            let productViewBackgroundImage = dataHoverImg ? dataHoverImg : dataModelImg;
            productGridItem.querySelector('a').style.backgroundImage = `url(${productViewBackgroundImage})`;
            break;
          case this.modelView.dataset.view:
            let modelViewBackgroundImage = dataHoverImg ? dataHoverImg : dataProductImg;
            productGridItem.querySelector('img').setAttribute('srcset', dataModelImg);
            productGridItem.querySelector('a').style.backgroundImage = `url(${modelViewBackgroundImage})`;
        }
      }
    }

    _onClickHandle(e) {
      if(!e.target.dataset.view) return;
      let activeButton = e.target;
      let option = activeButton.dataset.view;
      if(this.hasAttribute('data-save-view-option')) {
        this.addOrUpdateURLParam(this.getParam, option);
        document.querySelector('component-collection-filter').searchParamsPrev =  window.location.search.slice(1);
      }
      this.toggleProductModelViewButton(option);
    }

    addEventListeners() {
      this.addEventListener('click', this._onClickHandle.bind(this));
    }
  });
}
